import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofBar() {
  return <section className="w-full bg-light-green py-12 px-4" data-id="element-295">
      <div className="max-w-6xl mx-auto" data-id="element-296">
        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 divide-x-0 md:divide-x divide-green-200 mb-12 text-center" data-id="element-297">
          <div className="flex flex-col" data-id="element-298">
            <span className="text-3xl md:text-4xl font-extrabold text-deep-green" data-id="element-299">
              +500
            </span>
            <span className="text-sm text-green-800 font-medium mt-1" data-id="element-300">
              docentes confían
            </span>
          </div>
          <div className="flex flex-col" data-id="element-301">
            <span className="text-3xl md:text-4xl font-extrabold text-deep-green" data-id="element-302">
              12+6
            </span>
            <span className="text-sm text-green-800 font-medium mt-1" data-id="element-303">
              Tomos + Bonus
            </span>
          </div>
          <div className="flex flex-col" data-id="element-304">
            <span className="text-3xl md:text-4xl font-extrabold text-deep-green" data-id="element-305">
              4.9/5
            </span>
            <span className="text-sm text-green-800 font-medium mt-1" data-id="element-306">
              calificación ⭐
            </span>
          </div>
          <div className="flex flex-col" data-id="element-307">
            <span className="text-3xl md:text-4xl font-extrabold text-deep-green" data-id="element-308">
              🇦🇷
            </span>
            <span className="text-sm text-green-800 font-medium mt-1" data-id="element-309">
              Todo el país
            </span>
          </div>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-310">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-6 rounded-xl shadow-sm border border-green-50" data-id="element-311">
            <div className="flex items-center gap-3 mb-4" data-id="element-312">
              <div className="w-10 h-10 rounded-full bg-deep-green flex items-center justify-center text-white font-bold text-sm" data-id="element-313">
                MG
              </div>
              <div className="flex text-gold text-sm" data-id="element-314">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-gray-800 text-sm leading-relaxed mb-4 italic" data-id="element-315">
              "Organicé todo el año de Português en una tarde. Nunca más llegué
              sin material al aula."
            </p>
            <p className="text-xs text-gray-500 font-medium" data-id="element-316">
              — Mariela G., Córdoba | Docente de Português
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-green-50" data-id="element-317">
            <div className="flex items-center gap-3 mb-4" data-id="element-318">
              <div className="w-10 h-10 rounded-full bg-deep-green flex items-center justify-center text-white font-bold text-sm" data-id="element-319">
                LP
              </div>
              <div className="flex text-gold text-sm" data-id="element-320">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-gray-800 text-sm leading-relaxed mb-4 italic" data-id="element-321">
              "Las actividades están perfectamente pensadas para el alumno
              argentino. Las rúbricas me ahorran horas cada semana."
            </p>
            <p className="text-xs text-gray-500 font-medium" data-id="element-322">
              — Laura P., Rosario | Docente de Português
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}